import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api.interface';
import { RoleModule, UpdateRoleModuleDto } from '../models/role-module.model';

@Injectable({
  providedIn: 'root'
})
export class AdminRoleModulesService {
  private baseUrl = '/api/role-modules';
  
  constructor(private http: HttpClient) {}
  
  /**
   * Get all role-module relationships for a specific role
   */
  getRoleModules(roleId: number): Observable<ApiResponse<RoleModule[]>> {
    return this.http.get<ApiResponse<RoleModule[]>>(`${this.baseUrl}/role/${roleId}`);
  }
  
  /**
   * Update role-module permissions (bulk update)
   */
  updateRoleModules(roleId: number, permissions: UpdateRoleModuleDto[]): Observable<ApiResponse<RoleModule[]>> {
    return this.http.put<ApiResponse<RoleModule[]>>(`${this.baseUrl}/role/${roleId}`, { permissions });
  }
  
  /**
   * Get modules for current user's role
   */
  getMyModules(): Observable<ApiResponse<RoleModule[]>> {
    return this.http.get<ApiResponse<RoleModule[]>>(`${this.baseUrl}/my-modules`);
  }
}
